import * as angular from "angular";
import "./fleetEventListItem.component.scss";

interface IComponentBindings {
    startText?: string;
    endText?: string;
}

class Controller implements angular.IComponentController, IComponentBindings {
    startText: string;
    endText: string;

    static $inject = [
    ];

    constructor() {
    }

    $onInit(): void {
    }

    $onChanges(): void {
    }
}

export class FleetEventListItemComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            startText: "<?",
            endText: "<?"
        };

        this.controller = Controller;
        this.template = require("./fleetEventListItem.component.html");
    }
}
